import type { DateRangePreset, KpiMetric } from '../../types/analytics';

export function formatMetricValue(metric: KpiMetric): string {
  if (metric.format === 'percent') return `${(metric.value * 100).toFixed(1)}%`;
  if (metric.format === 'duration') {
    const secs = Math.round(metric.value);
    const m = Math.floor(secs / 60);
    const s = secs % 60;
    return m > 0 ? `${m}m ${s}s` : `${s}s`;
  }
  if (metric.format === 'string') return metric.label;
  if (metric.value >= 1_000_000) return `${(metric.value / 1_000_000).toFixed(1)}M`;
  if (metric.value >= 1_000) return `${(metric.value / 1_000).toFixed(1)}K`;
  return Number.isInteger(metric.value) ? String(metric.value) : metric.value.toFixed(1);
}

export function trendPercent(current: number, previous: number | null): number | null {
  if (previous === null || previous === 0) return null;
  return ((current - previous) / Math.abs(previous)) * 100;
}

export const KPI_INSIGHTS: Record<string, string> = {
  'Active Users':
    'Unique users who engaged with the site. Growing = healthy reach. Check traffic sources if declining.',
  Sessions:
    'Total visits (one user can have multiple). Low vs users = poor retention. High = good engagement loops.',
  'Page Views':
    'Total pages loaded. Low per session = users leave early. Check top pages for content gaps.',
  'Bounce Rate':
    'Single-page visits with no interaction. Below 40% is good. Above 60% = landing pages need work.',
  'Avg Session Duration':
    'Time spent per visit. Over 2 min is solid. Under 1 min = content not engaging enough.',
  'Pages / Session':
    'Pages viewed per visit. Above 2 is healthy. Low = weak internal linking or navigation.',
  'New Users':
    'First-time visitors. Growth means acquisition is working. Check sources driving new traffic.',
  'Returning Users':
    'Repeat visitors. High = strong brand recall. Low = no reason to come back. Add value content.',
  'Top Source':
    'Where most traffic comes from. Diversify if one source dominates — risky if it drops.',
};

export const COMPARISON_LABELS: Record<DateRangePreset, string> = {
  '7d': 'vs previous 7 days',
  '30d': 'vs previous 30 days',
  '90d': 'vs previous 90 days',
  '12mo': 'vs previous 12 months',
};
